import { Box, Modal, Typography } from "@mui/material";
import ButtonComponent from "../Inputs/ButtonComponent";
import "../../CSS/ComponentCSS/MarketingConsentFormModal.css";

type MarketingConsentFormProps = {
  open: boolean;
  onClose: (value: boolean) => void;
  cancel?: boolean;
  language: number;
};
export default function MarketingConsentFormModal(
  props: MarketingConsentFormProps
) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className="MarketingConsentFormModalBox">
        <Typography variant="h4" style={{ marginBottom: "10px" }}>
          {props.language == 1
            ? "* 마케팅 정보 수신"
            : props.language == 2
            ? "* Receive marketing information"
            : props.language == 3
            ? "* マーケティング情報を受け取る"
            : props.language == 4
            ? "* 接收营销信息"
            : props.language == 5
            ? "* 接收行銷訊息"
            : ""}
        </Typography>
        {props.language == 1 ? (
          <Typography variant="body1">
            주식회사 오콜로르 (이하 '오콜로르')는 개인정보보호법 및
            정보통신망이용촉진 및 정보보호 등에 관한 법률 등 관계법령에 따라
            광고성 정보를 전송하기 위해 이용자의 사전 수신 동의를 받고있습니다.
            본 내용은 오콜로르 컨설팅 프로그램 회원 서비스가 적용되는
            개별서비스의 마케팅 수신동의를 포함하고 있으며, 마케팅 정보 수신
            동의 시 개별서비스의 마케팅 수신에 일괄 동의한 것으로 처리됩니다.
            1.전송방법 마케팅 정보 전송 방법은 오콜로르 서비스 및 오콜로르
            컨설팅 프로그램 각 개별서비스에서 정한 방식에 따라 전송됩니다. 2.
            전송내용 발송되는 마케팅 정보는 수신자에게 오콜로르 및 오콜로르
            컨설팅 프로그램 개별서비스에서 제공하는 혜택(포인트, 쿠폰 등) 정보,
            각종 이벤트, 신규 상품 관련 소식 등 광고성 정보로 관련 법의 규정을
            준수하여 발송됩니다. 단, 광고성 정보 이외에 의무적으로 안내 되어야
            하는 정보성 내용은 수신동의 여부와 무관하게 제공됩니다. 3. 수집항목
            - 성별, 연령, 국가, 지역, 이메일, 이름, 전화번호 4. 이용목적 -
            소식지 서비스 제공, 신제품 및 이벤트 안내, 이벤트 경품/사은품 제공,
            할인행사, 고객 맞춤 마케팅/판촉 등 관련 이메일 및 SMS 등 발송 5.
            철회안내 - 수신동의 이후에라도 언제든지 동의를 철회할 수 있으며,
            수신을 동의하지 않아도 회사가 제공하는 기본적인 서비스를 이용하실 수
            있습니다. 다만 수신 거부할 경우 신규 서비스나 상품 관련 소식 등의
            마케팅 정보를 제공받지 못할 수 있습니다. 6. 수신동의 변경 및
            보유기간 - 보유 기간 : 마케팅 정보 수신 동의로부터 2년, 기간 초과 시
            동의 절차 재진행 (미동의 시, 즉시 파기) 오콜로르 컨설팅 프로그램
            정보수정 페이지에서 개별서비스의 마케팅 수신동의를 변경(동의/철회)할
            수 있으며, 동의일로부터 회원 탈퇴 혹은 마케팅 수신 동의 해제 시까지
            광고성 정보 전달을 위하여 보유ㆍ이용 됩니다.
          </Typography>
        ) : props.language == 2 ? (
          <Typography variant="body1">
            Ocollor Co., Ltd. (hereinafter referred to as “ Ocollor ”) complies
            with the Personal Information Protection Act and In accordance with
            relevant laws and regulations, including the Act on Promotion of
            Information and Communications Network Utilization and Information
            Protection, etc. We are seeking prior consent from users to send
            promotional information . This content applies to the Ocollor
            Consulting Program membership service. Includes consent to receive
            marketing information for individual services If you agree, you will
            be considered to have agreed to receive marketing for individual
            services. 1. Method of transmission Marketing information
            transmission method is Ocollor service and Ocollor Consulting
            programs are transmitted according to the method set by each
            individual service. 2. Marketing information sent to the recipients
            is provided by Ocollor and Ocollor. Information on benefits (points,
            coupons, etc.) provided by individual consulting program services
            Advertising information such as news about various events and new
            products, etc., in violation of relevant laws and regulations. be
            provided in addition to advertising information. Informational
            content is provided regardless of whether you consent to receiving
            it. 3. Collection items - Gender, age, country, region, email, name,
            phone number 4. Purpose of use - Providing newsletter services,
            providing information on new products and events, and providing
            event prizes/gifts. 5. Sending emails and SMS messages related to
            discount events, customer-tailored marketing/promotions, etc.
            Withdrawal Guide - You may withdraw your consent at any time, even
            after consenting to receive information. You can use the basic
            services provided by the company even if you do not agree to receive
            them. Yes. However, if you opt out, you will receive news about new
            services or products. You may not receive marketing information. 6.
            Changes to consent to receive and Retention period - Retention
            period: 2 years from consent to receive marketing information, if
            the period is exceeded Re-running the consent procedure (if not
            consented, immediately terminated) Ocollor Consulting Program You
            can change (agree/withdraw) your consent to receive marketing
            information for individual services on the information modification
            page. You may withdraw your membership or cancel your consent to
            receive marketing from the date of consent. retained and used for
            the purpose of delivering advertising information .
          </Typography>
        ) : props.language == 3 ? (
          <Typography variant="body1">
            株式会社オコロール（以下「オコロール」 ）は、個人情報保護法および
            情報通信網利用促進及び情報保護等に関する法律等関係法令により
            広告性情報を送信するために利用者の事前受信同意を受けています。
            本内容はオコロールコンサルティングプログラム会員サービスが適用される
            個別サービスのマーケティング受信同意を含み、マーケティング情報の受信
            同意の際、個別サービスのマーケティング受信に一括同意したものとして処理されます。
            1.転送方法
            マーケティング情報の転送方法はオコロールサービス及びオコロール
            コンサルティングプログラム各個別サービスで定めた方法で送信されます。
            2. 、受信者にオコロールおよびオコロール
            コンサルティングプログラム個別サービスが提供する特典（ポイント、クーポンなど）情報、
            各種イベント、新規商品関連のお知らせなど広告性情報で関連法の規定を
            遵守して発送されます。ただし、広告性情報に加えて義務的に案内されなければならない
            する情報性内容は、受信同意の有無に関係なく提供されます。 3. 収集項目
            - 性別、年齢、国、地域、電子メール、名前、電話番号 4. 利用目的 -
            お知らせサービスの提供、新製品及びイベント案内、イベント賞品・贈答品の提供、
            割引イベント、顧客カスタマイズマーケティング/プロモーションなどの関連メール、SMSなどの発送5。
            撤回案内 - 受信同意の後でもいつでも同意を撤回することができ、
            受信に同意しなくても、会社が提供する基本的なサービスを利用できます。
            ただ、受信拒否する場合、新規サービスや商品関連のお知らせなどの
            マーケティング情報が提供されない場合があります。 保有期間 -
            保有期間：マーケティング情報受信同意から2年、期間超過時
            同意手続きの再進行（未同時、即時破棄）オコロールコンサルティングプログラム
            情報修正ページで個別サービスのマーケティング受信同意を変更（同意／撤回）する
            同意日から会員脱退またはマーケティング受付同意解除時まで
            広告性情報配信のために保有・利用されます。
          </Typography>
        ) : props.language == 4 ? (
          <Typography variant="body1">
            Okolor株式会社（以下简称“ Ocollor ”）遵守个人信息保护法，
            根据《信息通信网络利用促进及信息保护法》等相关法律法规。
            我们正在寻求用户事先同意发送促销信息。
            此内容适用于Okolor咨询计划会员服务。 包括同意接收个人服务的营销信息
            如果您同意，则视为您同意接收针对单项服务的营销信息。 1.
            传播方式营销信息传播方式为Okolor服务和Okolor
            咨询计划按照每个单独服务设定的方法传送。2. Okolor和Okolor提供。
            个人咨询计划服务提供的优惠信息（积分、优惠券等）
            发布各种活动新闻、新产品新闻等违反相关法律法规的广告信息。
            除广告信息外，还必须提供这些信息。
            无论您是否同意接收，信息内容都会提供。3. 收集项目 -
            性别、年龄、国家、地区、电子邮件、姓名、电话号码4.使用目的-
            提供时事通讯服务、提供新产品和活动信息以及提供活动奖品/礼品。 5.
            发送与折扣活动、客户定制营销/促销等相关的电子邮件和短信。 撤回指南
            -即使同意接收信息后，您也可以随时撤回您的同意。
            即使您不同意接收公司提供的基本服务，您也可以使用。
            是的。但是，如果您选择退出，您将收到有关新服务或产品的新闻。
            您可能无法收到营销信息。6. 同意接收和 保留期限 -
            保留期限：自同意接收营销信息之日起 2 年，如果超过期限
            重新运行同意程序（如不同意，则立即终止） Okolor咨询计划
            您可以在信息修改页面更改（同意/撤回）接收单项服务营销信息的同意。
            您可以从同意之日起撤回您的会员资格或取消接收营销信息的同意。
            被保留并用于传递广告信息。
          </Typography>
        ) : props.language == 5 ? (
          <Typography variant="body1">
            Okolor株式會社（以下簡稱「 Ocollor 」）遵守個人資訊保護法，
            根據《資訊通信網路利用促進及資訊保護法》等相關法律法規。
            我們正在尋求用戶事先同意發送促銷訊息。
            此內容適用於Okolor諮詢計劃會員服務。 包括同意接收個人服務的行銷訊息
            如果您同意，則視為您同意接收針對單項服務的行銷訊息。 1.
            傳播方式行銷訊息傳播方式為Okolor服務和Okolor
            諮詢計劃按照每個單獨服務設定的方法傳送。 2. Okolor和Okolor提供。
            個人諮詢計畫服務提供的優惠資訊（積分、優惠券等）
            發佈各種活動新聞、新產品新聞等違反相關法律法規的廣告訊息。
            除廣告訊息外，還必須提供這些資訊。
            無論您是否同意接收，資訊內容都會提供。 3. 收集項目 -
            性別、年齡、國家、地區、電子郵件、姓名、電話號碼4.使用目的-
            提供電子報服務、提供新產品和活動資訊以及提供活動獎品/禮品。 5.
            發送與折扣活動、顧客客製化行銷/促銷等相關的電子郵件和簡訊。 撤回指南
            -即使同意接收資訊後，您也可以隨時撤回您的同意。
            即使您不同意接收公司提供的基本服務，您也可以使用。
            是的。但是，如果您選擇退出，您將收到有關新服務或產品的新聞。
            您可能無法收到行銷訊息。 6. 同意接收和 保留期限 -
            保留期限：自同意接收行銷訊息之日起 2 年，如果超過期限
            重新執行同意程序（如不同意，則立即終止） Okolor諮詢計劃
            您可以在資訊修改頁面變更（同意/撤回）接收單項服務行銷訊息的同意。
            您可以從同意之日起撤回您的會員資格或取消接收行銷訊息的同意。
            保留並用於傳遞廣告訊息。
          </Typography>
        ) : (
          ""
        )}

        <div className="MarketingConsentFormModalBottom">
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={() => props.onClose(true)}
            className="MemberUpdateButton"
          >
            {props.language == 1
              ? "확인"
              : props.language == 2
              ? "Check"
              : props.language == 3
              ? "確認"
              : props.language == 4
              ? "查看"
              : props.language == 5
              ? "查看"
              : ""}
          </ButtonComponent>
          {props.cancel && (
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(false)}
              className="MemberDeleteButton"
            >
              {props.language == 1
                ? "취소"
                : props.language == 2
                ? "Cancel"
                : props.language == 3
                ? "キャンセル"
                : props.language == 4
                ? "消除"
                : props.language == 5
                ? "消除"
                : ""}
            </ButtonComponent>
          )}
        </div>
      </Box>
    </Modal>
  );
}
